<div class="page_layout">
  <div class="logo" (click)="onWeb()">
    <img src="/images/aradalogo.png" alt="aradalogo" class="logo--image" />
  </div>

  <p class="title">Choose Language:</p>
  <div class="language_options">
    <div class="lan" (click)="redirectTr()">
      <app-language-option [input_option]="'Türkçe'" (click)="onTurkish()" />
    </div>
    <div class="lan" (click)="redirectEn()">
      <app-language-option [input_option]="'English'" (click)="onEnglish()" />
    </div>
    <div class="lan lan--ar" (click)="redirectAr()">
      <app-language-option [input_option]="'العربية'" (click)="onArabic()" />
    </div>
  </div>

  <app-order-list-button />
</div>
